import axios from "../../utils/axios";

export const getBlog = async (id) => {
  const response = await axios.get(`/blogs/${id}`);

  return response.data;
};
export const updateBlog = async (updatedData) => {
  console.log(updatedData);
  const response = await axios({
    method: "put",
    url: `/blogs/${updatedData.id}`,
    data: { ...updatedData },
  });

  return response.data;
};
